import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getTipoEsquema (files, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getTipoEsquema)
    })
  } else {
    const formData = new FormData()
    files.forEach(file => {
      formData.append('file', file.raw)
    })

    const req = {
      url: 'api/facturas/gettipoesquema',
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data'
      },
      params,
      data: formData,
      timeout: 300000,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getTipoEsquema }
